import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, Typography } from '@mui/material';
import React from 'react';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import { getFormattedDate } from 'src/shared/utils/dates';
import { useCompareContext } from '../Context';
const BelowSections = props => {
  const $ = _c(10);
  const {
    compareData: t0
  } = useCompareContext();
  const {
    belowSectionsContent,
    updatedDate
  } = t0;
  let t1;
  if ($[0] !== updatedDate) {
    t1 = updatedDate ? getFormattedDate(updatedDate, "MMMM d, yyyy") : undefined;
    $[0] = updatedDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  let t2;
  if ($[2] !== formattedDate) {
    t2 = formattedDate ? <Typography data-testid="compare-last-updated" variant="notesSmall" sx={{
      mb: 2
    }}>Last updated on {formattedDate}</Typography> : null;
    $[2] = formattedDate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== belowSectionsContent) {
    t3 = <StructuredContentRenderer doc={belowSectionsContent} />;
    $[4] = belowSectionsContent;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t2 || $[8] !== t3) {
    t4 = <Box {...props}>{t2}{t3}</Box>;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default BelowSections;